import { Select } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { apiSlice } from "../../../apiSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useGetIssueBoardsQuery } from "./IssueBoardRTK";
import { resetIssueRedux, setCurrentIssueboardId } from "./issueSlice";
import { resetIssueBoardThunk } from "./issueThunk";
import { getIssueBoardIdFromUrl } from "./issueUtils";

const BoardSelector: React.FC<{}> = () => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const dispatch = useAppDispatch();
  const { data: issueBoards = [], isLoading } = useGetIssueBoardsQuery({
    projectId: project._id,
  });
  const history = useHistory();
  const activeIssueBoardId = getIssueBoardIdFromUrl(history.location.pathname);
  const activeBoard = issueBoards.find((board) => board._id === activeIssueBoardId);

  const goToBoard = (boardId: string | null) => {
    dispatch(apiSlice.util.invalidateTags(["IssueBoard"]));
    if (boardId === "selection") {
      dispatch(resetIssueRedux());
      history.replace(`/project/${project._id}/issues`);
    } else if (boardId) {
      if (boardId !== activeIssueBoardId) {
        dispatch(resetIssueBoardThunk());
      }
      dispatch(setCurrentIssueboardId(boardId));
      history.replace(`/project/${project._id}/issues/${boardId}`);
    }
  };

  return (
    <>
      {activeBoard == null && isLoading === false && <span>Register ikke funnet</span>}
      {issueBoards.length > 0 && (
        <Select
          w={"lg"}
          size="sm"
          value={activeBoard?._id || "selection"}
          onChange={goToBoard}
          placeholder="Velg register"
          data={[
            ...issueBoards
              .filter((board) => board.status === "ACTIVE")
              .map((board) => ({
                value: board._id,
                label: board.name,
              })),
            { value: "selection", label: "Gå til Utvalg" },
          ]}
          style={{ minWidth: "200px" }}
          searchable
        />
      )}
    </>
  );
};

export default BoardSelector;
